<template>
  <div>
    <!-- 個人頁 -->
    <div class="content my-invite">
      <div class="my-invite-frame">
        <div class="my-info">
          <h4 class="invite-title only-mobile">
            {{ $t("Bao.user-friend") }}
          </h4>
          <div class="vip-info vip-info-type-v2">
            <div class="vip-info-group">
              <div class="vip-info-items left-items">
                <div class="vip-title">
                  {{ $t("Bao.commission_gold") }}：
                </div>
                <div class="text-align-R r-side">
                  <span class="invite-t-s">{{ $store.state.brand.currency }}{{ $store.getters.commissionGold | numberFormat }}</span>
                </div>
              </div>
              <div class="vip-info-items left-items">
                <div class="vip-title">
                  {{ $t("Bao.promoter_003") }}：
                </div>
                <div class="text-align-R r-side">
                  <span class="invite-t-s">{{ passPeopleNum }}</span>{{ $t("Bao.people") }}
                </div>
              </div>
              <div class="vip-info-items left-items">
                <div class="vip-title">
                  {{ $t("Bao.promoter_002") }}：
                </div>
                <div class="text-align-R r-side">
                  <span class="invite-t-s">{{ detail.children_count }}</span>{{ $t("Bao.people") }}
                </div>
              </div>
            </div>
            <div class="vip-info-group">
              <div class="vip-info-items right-items">
                <div class="vip-title">
                  {{ $t("Bao.promoter_006") }}
                </div>
                <div class="vip-cage text-align-R">
                  <div class="input-cage">
                    {{ promotion_url }}
                  </div>
                </div>
                <div class="icon-btn" @click="copyText(promotion_url)">
                  <a class="vip-icon-box" href="javascript:;">
                    <img :src="getThemeImagePath('icon_copy_white.png')">
                  </a>
                </div>
              </div>
              <div class="vip-info-items right-items">
                <div class="vip-title">
                  {{ $t("Bao.promoter_004") }}
                </div>
                <div class="vip-cage text-align-R">
                  <div class="input-cage">
                    {{ detail.promotion_code }}
                  </div>
                </div>
                <div class="icon-btn" @click="copyText(detail.promotion_code)">
                  <a class="vip-icon-box" href="javascript:;">
                    <img :src="getThemeImagePath('icon_copy_white.png')">
                  </a>
                </div>
              </div>
              <div class="vip-info-items right-items">
                <div class="vip-title">
                  {{ $t("Bao.promoter_014") }}：
                </div>
                <div class="vip-cage text-align-R">
                  <div v-if="promotion_url" class="input-cage invite-qr-frame">
                    <qrcode-vue :value="promotion_url" :size="65" />
                  </div>
                </div>
                <div class="icon-btn" @click="downloadQRCode">
                  <a class="vip-icon-box" href="javascript:;">
                    <img :src="getThemeImagePath('icon_download_white.png')">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="waistband-frame">
          <div class="waistband">
            <p>
              上限無しの紹介者ボーナスが獲得できる、友達紹介特典好評開催中！
            </p>
          </div>
        </div>
        <div class="my-invite-bonus">
          <div class="invite-bonus">
            <p>
              <i>
                <img :src="getThemeImagePath('icon-invite-weekly.png')" alt="">
              </i>
              {{ $t("Bao.promoter_011") }}
              <span>{{ $t("Bao.promoter_012") }}</span>
            </p>
            <div v-if="weeklyReward.length === 0" class="invite-bonus-nodata">
              <div class="no-data">
                <i><img :src="getThemeImagePath('no-data.png')" alt=""></i>
                <p>{{ $t('Bao.no_relevant_data_records') }}</p>
                <span>{{ $t('Bao.search_results_are_empty') }}</span>
              </div>
            </div>
            <div v-show="weeklyReward.length > 0" class="invite-bonus-item invi-grid">
              <table class="invite-table">
                <tbody>
                  <tr>
                    <td>{{ $t("Bao.time") }}</td>
                    <td>
                      <span class="invite-date-stat">{{ lastWeekData.startDate }}</span> ~
                      <span class="invite-date-end">{{ lastWeekData.endDate }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("Bao.register_people_num") }}</td>
                    <td>{{ lastWeekData.totalRegisterMembers }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t("Bao.charge_people_num") }}</td>
                    <td>{{ lastWeekData.totalMembers }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t("Bao.promoter_011") }}</td>
                    <td>{{ lastWeekData.totalPrizeAmount }}</td>
                  </tr>
                </tbody>
              </table>

              <div class="btn-span">
                <button v-if="lastWeekData.canClaim" class="btn btn-claim" @click="claimRewardV4">
                  {{ $t("Bao.claim") }}
                </button>
                <button v-else-if="lastWeekData.status === 'claimed'" class="btn btn-claim">
                  {{ $t("Bao.claimed") }}
                </button>
                <button v-else-if="lastWeekData.status === 'unfinished'" class="btn btn-claim">
                  {{ $t("Bao.unfinished") }}
                </button>
              </div>
              <div class="invite-column arrow-span" :class="{active: isActive}" @click="toggleActive">
                <span class="icon"><i class="icon-arrow-L" /></span>
              </div>
            </div>
            <ul v-for="(item, key) in weeklyReward.slice(0,7)" v-show="isActive" :key="key" class="daily-frame">
              <li>
                <p class="items">
                  <span>{{ $t("Bao.time") }}</span>
                  <span>{{ $t("Bao.register_people_num") }}</span>
                  <span>{{ $t("Bao.charge_people_num") }}</span>
                  <span> {{ $t("Bao.promoter_011") }}</span>
                </p>
                <p class="items">
                  <span>{{ item.date }}</span>
                  <span>{{ item.register_member_num }}</span>
                  <span>{{ item.member === 0 ? 0 : item.member.length }}</span>
                  <span>{{ item.total_prize_amount | numberFormat }}</span>
                </p>
              </li>
            </ul>
            <div v-show="weeklyReward.length > 0" class="invite-bonus-item invi-grid">
              <table class="invite-table">
                <tbody>
                  <tr>
                    <td>{{ $t("Bao.time") }}</td>
                    <td>
                      <span class="invite-date-stat">{{ thisWeekData.startDate }}</span> ~
                      <span class="invite-date-end">{{ thisWeekData.endDate }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("Bao.register_people_num") }}</td>
                    <td>{{ thisWeekData.totalRegisterMembers }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t("Bao.charge_people_num") }}</td>
                    <td>{{ thisWeekData.totalMembers }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t("Bao.promoter_011") }}</td>
                    <td>{{ thisWeekData.totalPrizeAmount }}</td>
                  </tr>
                </tbody>
              </table>

              <div class="btn-span">
                <button v-if="thisWeekData.canClaim" class="btn btn-claim" @click="claimRewardV4">
                  {{ $t("Bao.claim") }}
                </button>
                <button v-else-if="thisWeekData.status === 'claimed'" class="btn btn-claim">
                  {{ $t("Bao.claimed") }}
                </button>
                <button v-else-if="thisWeekData.status === 'unfinished'" class="btn btn-claim">
                  {{ $t("Bao.unfinished") }}
                </button>
              </div>
              <div class="invite-column arrow-span" :class="{active: isActive2}" @click="toggleActive2">
                <span class="icon"><i class="icon-arrow-L" /></span>
              </div>
            </div>
            <ul v-for="(item, key) in filteredWeeklyReward().slice(7,15)" v-show="isActive2" :key="key+7" class="daily-frame">
              <li>
                <p class="items">
                  <span>{{ $t("Bao.time") }}</span>
                  <span>{{ $t("Bao.register_people_num") }}</span>
                  <span>{{ $t("Bao.charge_people_num") }}</span>
                  <span> {{ $t("Bao.promoter_011") }}</span>
                </p>
                <p class="items">
                  <span>{{ item.date }}</span>
                  <span>{{ item.register_member_num }}</span>
                  <span>{{ item.member === 0 ? 0 : item.member.length }}</span>
                  <span>{{ item.total_prize_amount | numberFormat }}</span>
                </p>
              </li>
            </ul>
          </div>
          <div class="invite-bonus">
            <p>
              <i>
                <img :src="getThemeImagePath('icon-invite-bonus.png')" alt="">
              </i>{{ $t("Bao.promoter_008") }}
              <span>{{ $t("Bao.promoter_012") }}</span>
            </p>
            <div v-if="weeklyTask.length === 0" class="invite-bonus-nodata">
              <div class="no-data">
                <i><img :src="getThemeImagePath('no-data.png')" alt=""></i>
                <p>{{ $t('Bao.no_relevant_data_records') }}</p>
                <span>{{ $t('Bao.search_results_are_empty') }}</span>
              </div>
            </div>
            <div>
              <div v-for="(item, key) in weeklyTask" :key="key" class="invite-bonus-item">
                <p>
                  <span>{{ $t("Bao.time") }}</span>
                  <span>{{ $t("Bao.normal_friend") }}</span>
                  <span>{{ $t("Bao.promoter_011") }}</span>
                </p>
                <p>
                  <span>{{ item.created_at | dateFormat }}</span>
                  <span>{{ item.count }}</span>
                  <span>{{ item.amount }}</span>
                </p>
                <p @click="claimReward(item)">
                  <button v-if="item.status === 3">
                    {{ $t("Bao.claimed") }}
                  </button>
                  <button v-else-if="item.status === 2" :class="{active: item.status === 2}">
                    {{ $t("Bao.claim") }}
                  </button>
                  <button v-else>
                    {{ $t("Bao.unfinished") }}
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="note-invite-frame-bg">
          <div class="note-invite-frame">
            <h5>
              {{ $t('Bao.friend_description_title') }}
            </h5>
            <ol>
              <li>
                {{ $t('Bao.friend_description_1') }}
              </li>
              <li>
                {{ $t('Bao.friend_description_2') }}
              </li>
            </ol>
            <p>
              {{ $t('Bao.friend_description_3') }}
              <br>
              {{ $t('Bao.friend_description_4') }}
            </p>
            <p>{{ $t('Bao.friend_description_5') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPromotionInfo, getPromotionShortUrl } from '@/api/user'
import { getEventDetail, getFriendTask, receive, receiveV2 } from '@/api/event'
import { copyText, showNotice, showRequest, getThemeImagePath } from '@/utils/tool'
import qrcodeVue from 'qrcode.vue'

export default {
  components: {
    'qrcode-vue': qrcodeVue
  },
  data() {
    return {
      detail: {},
      weeklyReward: [],
      weeklyTask: [],
      isV4EventClear: null,
      isActive: false,
      isActive2: false,
      lastWeekData: {
        startDate: '',
        endDate: '',
        totalRegisterMembers: 0,
        totalMembers: 0,
        totalPrizeAmount: 0,
        claimable: true,
        status: null
      },
      thisWeekData: {
        startDate: '',
        endDate: '',
        totalRegisterMembers: 0,
        totalMembers: 0,
        totalPrizeAmount: 0,
        claimable: true,
        today: 0,
        status: null
      },
      promotion_url: null
    }
  },
  computed: {
    passPeopleNum() {
      return this.weeklyReward.reduce((acc, item) => {
        return (item.status === 2 || item.status === 3) ? acc + 1 : acc
      }, 0)
    },
    displayText() {
      return `${this.$t('Bao.main_turnover')}: ${this.$store.state.user.memberInfo.main_turnover}<br>
            ${this.$t('Bao.withdrawal_lim')}: ${this.$store.state.user.memberInfo.withdrawal_limit}<br>
            ${this.$t('Bao.receive_clear')}`
    }
  },
  watch: {
    async '$store.getters.isApiExecute'(to) {
      if (to) {
        try {
          for (const item of this.weeklyReward) {
            if (item.status === 2) {
              await receiveV2(item.event_member_id)
            }
          }
          this.$store.commit('SET_API_EXECUTE', false)
          this.getReward()
          this.getFriend()
        } catch (error) {
          console.log(error)
        }
      }
    }
  },
  async created() {
    try {
      const res = await getPromotionInfo()
      this.detail = res.data.data

      try {
        const shortUrl = await getPromotionShortUrl()
        this.promotion_url = shortUrl.data.data.promotion_url
      } catch (error) {
        console.error(error)
      }
    } catch (error) {
      showNotice(error.response.data.msg)
    }
    this.getReward()
    this.getFriend()
  },
  methods: {
    copyText(msg) {
      copyText(msg, this.promotion_url)
    },
    toggleActive() {
      this.isActive = !this.isActive
    },
    toggleActive2() {
      this.isActive2 = !this.isActive2
    },
    filteredWeeklyReward() {
      const today = new Date().toISOString().split('T')[0]
      return this.weeklyReward.filter(item => item.date <= today)
    },
    prevWeekData() {
      if (!this.weeklyReward.length) return null

      const startDate = this.weeklyReward[0].date
      const endDate = this.weeklyReward[this.weeklyReward.length - 8].date

      const aggregatedData = {
        startDate: startDate,
        endDate: endDate,
        totalRegisterMembers: 0,
        totalMembers: 0,
        totalPrizeAmount: 0,
        canClaim: false,
        status: null
      }

      this.weeklyReward.slice(0, 7).forEach(item => {
        aggregatedData.totalRegisterMembers += item.register_member_num
        aggregatedData.totalMembers += item.member === 0 ? 0 : item.member.length
        aggregatedData.totalPrizeAmount += parseInt(item.total_prize_amount)
      })
      aggregatedData.canClaim = this.weeklyReward.slice(0, 7).some(item => item.status === 2)
      if (this.weeklyReward.slice(0, 7).some(item => item.status === 0)) {
        aggregatedData.status = 'unfinished'
      }
      if (this.weeklyReward.slice(0, 7).some(item => item.status === 3)) {
        aggregatedData.status = 'claimed'
      }
      this.lastWeekData = aggregatedData
    },
    currentWeekData() {
      if (!this.weeklyReward.length) return null

      const startDate = this.weeklyReward[this.weeklyReward.length - 7].date
      const endDate = this.weeklyReward[this.weeklyReward.length - 1].date

      const aggregatedData = {
        startDate: startDate,
        endDate: endDate,
        totalRegisterMembers: 0,
        totalMembers: 0,
        totalPrizeAmount: 0,
        claimable: true,
        today: 0,
        status: null
      }

      this.weeklyReward.slice(7, 15).forEach(item => {
        aggregatedData.totalRegisterMembers += item.register_member_num
        aggregatedData.totalMembers += item.member === 0 ? 0 : item.member.length
        aggregatedData.totalPrizeAmount += parseInt(item.total_prize_amount)
      })
      aggregatedData.canClaim = this.weeklyReward.slice(7, 15).some(item => item.status === 2)
      if (this.weeklyReward.slice(7, 15).some(item => item.status === 0)) {
        aggregatedData.status = 'unfinished'
      }
      if (this.weeklyReward.slice(7, 15).some(item => item.status === 3)) {
        aggregatedData.status = 'claimed'
      }
      this.thisWeekData = aggregatedData
    },
    async getReward() {
      try {
        if (this.$store.state.user.eventV4Ids) {
          const res = await getEventDetail(this.$store.state.user.eventV4Ids)
          this.weeklyReward = res.data.data.reward
          this.isV4EventClear = res.data.data.after_deliver ? res.data.data.after_deliver.action : null
          this.prevWeekData()
          this.currentWeekData()
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getFriend() {
      try {
        const res = await getFriendTask()
        this.weeklyTask = res.data.data.reward
      } catch (e) {
        console.log(e)
      }
    },
    async claimReward(item) {
      if (item.status !== 2) return
      try {
        await receive(item.id)
        this.getReward()
        this.getFriend()
      } catch (error) {
        console.log(error)
      }
    },
    async claimRewardV4() {
      if (this.isV4EventClear) {
        showRequest(this.displayText)
      } else {
        try {
          for (const item of this.weeklyReward) {
            if (item.status === 2) {
              await receiveV2(item.event_member_id)
            }
          }
          this.getReward()
          this.getFriend()
        } catch (error) {
          console.log(error)
        }
      }
    },
    downloadQRCode() {
      this.$nextTick(() => {
        const canvas = this.$el.querySelector('.invite-qr-frame canvas')
        if (canvas) {
          const imageUrl = canvas.toDataURL('image/png')
          const link = document.createElement('a')
          link.href = imageUrl
          link.download = 'QRCode.png'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      })
    },
    getThemeImagePath
  }
}
</script>
